/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ExtendedUserDTO extends User model to provide username
 * @export
 * @interface UserDetailsDTO
 */
export interface UserDetailsDTO {
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    activationToken?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailsDTO
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    companyLicense?: UserDetailsDTOCompanyLicenseEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    credentialsId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailsDTO
     */
    enabledNFAEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailsDTO
     */
    enabledNFAOPT?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    firstSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    id?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailsDTO
     */
    logisticOperationsPermissions?: Set<UserDetailsDTOLogisticOperationsPermissionsEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailsDTO
     */
    masterdataPermissions?: Set<UserDetailsDTOMasterdataPermissionsEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailsDTO
     */
    reportsPermissions?: Set<UserDetailsDTOReportsPermissionsEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailsDTO
     */
    roles?: Set<UserDetailsDTORolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    secondSurname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    tenantId?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserDetailsDTO
     */
    trackAndTracePermissions?: Set<UserDetailsDTOTrackAndTracePermissionsEnum>;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailsDTO
     */
    validated?: UserDetailsDTOValidatedEnum;
}


/**
 * @export
 */
export const UserDetailsDTOCompanyLicenseEnum = {
    Im: 'IM',
    Wm: 'WM',
    WmWithContainer: 'WM_WITH_CONTAINER'
} as const;
export type UserDetailsDTOCompanyLicenseEnum = typeof UserDetailsDTOCompanyLicenseEnum[keyof typeof UserDetailsDTOCompanyLicenseEnum];

/**
 * @export
 */
export const UserDetailsDTOLogisticOperationsPermissionsEnum = {
    InventoryMaterial: 'INVENTORY_MATERIAL',
    MaterialEntry: 'MATERIAL_ENTRY',
    MaterialExit: 'MATERIAL_EXIT'
} as const;
export type UserDetailsDTOLogisticOperationsPermissionsEnum = typeof UserDetailsDTOLogisticOperationsPermissionsEnum[keyof typeof UserDetailsDTOLogisticOperationsPermissionsEnum];

/**
 * @export
 */
export const UserDetailsDTOMasterdataPermissionsEnum = {
    Company: 'COMPANY',
    Customer: 'CUSTOMER',
    Family: 'FAMILY',
    FamilyType: 'FAMILY_TYPE',
    Location: 'LOCATION',
    Manufacturer: 'MANUFACTURER',
    Material: 'MATERIAL',
    Operator: 'OPERATOR',
    Owner: 'OWNER',
    Supplier: 'SUPPLIER',
    TileTemplate: 'TILE_TEMPLATE',
    User: 'USER',
    Warehouse: 'WAREHOUSE',
    WarehouseViewer: 'WAREHOUSE_VIEWER',
    Zone: 'ZONE'
} as const;
export type UserDetailsDTOMasterdataPermissionsEnum = typeof UserDetailsDTOMasterdataPermissionsEnum[keyof typeof UserDetailsDTOMasterdataPermissionsEnum];

/**
 * @export
 */
export const UserDetailsDTOReportsPermissionsEnum = {
    InventoryRegistry: 'INVENTORY_REGISTRY',
    InventoryReport: 'INVENTORY_REPORT',
    MovementsReport: 'MOVEMENTS_REPORT',
    RelabelReport: 'RELABEL_REPORT',
    StockReport: 'STOCK_REPORT',
    WarehouseStatus: 'WAREHOUSE_STATUS'
} as const;
export type UserDetailsDTOReportsPermissionsEnum = typeof UserDetailsDTOReportsPermissionsEnum[keyof typeof UserDetailsDTOReportsPermissionsEnum];

/**
 * @export
 */
export const UserDetailsDTORolesEnum = {
    MobAdmin: 'MOB_ADMIN',
    MobUser: 'MOB_USER',
    PortalAdmin: 'PORTAL_ADMIN',
    PortalUser: 'PORTAL_USER',
    SuperAdmin: 'SUPER_ADMIN'
} as const;
export type UserDetailsDTORolesEnum = typeof UserDetailsDTORolesEnum[keyof typeof UserDetailsDTORolesEnum];

/**
 * @export
 */
export const UserDetailsDTOTrackAndTracePermissionsEnum = {
    Hierarchy: 'HIERARCHY',
    Product: 'PRODUCT'
} as const;
export type UserDetailsDTOTrackAndTracePermissionsEnum = typeof UserDetailsDTOTrackAndTracePermissionsEnum[keyof typeof UserDetailsDTOTrackAndTracePermissionsEnum];

/**
 * @export
 */
export const UserDetailsDTOValidatedEnum = {
    Accepted: 'ACCEPTED',
    Denied: 'DENIED',
    Requested: 'REQUESTED'
} as const;
export type UserDetailsDTOValidatedEnum = typeof UserDetailsDTOValidatedEnum[keyof typeof UserDetailsDTOValidatedEnum];


/**
 * Check if a given object implements the UserDetailsDTO interface.
 */
export function instanceOfUserDetailsDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserDetailsDTOFromJSON(json: any): UserDetailsDTO {
    return UserDetailsDTOFromJSONTyped(json, false);
}

export function UserDetailsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activationToken': !exists(json, 'activationToken') ? undefined : json['activationToken'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'companyLicense': !exists(json, 'companyLicense') ? undefined : json['companyLicense'],
        'credentialsId': !exists(json, 'credentialsId') ? undefined : json['credentialsId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'enabledNFAEmail': !exists(json, 'enabledNFAEmail') ? undefined : json['enabledNFAEmail'],
        'enabledNFAOPT': !exists(json, 'enabledNFAOPT') ? undefined : json['enabledNFAOPT'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'firstSurname': !exists(json, 'firstSurname') ? undefined : json['firstSurname'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'logisticOperationsPermissions': !exists(json, 'logisticOperationsPermissions') ? undefined : json['logisticOperationsPermissions'],
        'masterdataPermissions': !exists(json, 'masterdataPermissions') ? undefined : json['masterdataPermissions'],
        'reportsPermissions': !exists(json, 'reportsPermissions') ? undefined : json['reportsPermissions'],
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
        'secondSurname': !exists(json, 'secondSurname') ? undefined : json['secondSurname'],
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'trackAndTracePermissions': !exists(json, 'trackAndTracePermissions') ? undefined : json['trackAndTracePermissions'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'validated': !exists(json, 'validated') ? undefined : json['validated'],
    };
}

export function UserDetailsDTOToJSON(value?: UserDetailsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activationToken': value.activationToken,
        'active': value.active,
        'companyLicense': value.companyLicense,
        'credentialsId': value.credentialsId,
        'email': value.email,
        'enabledNFAEmail': value.enabledNFAEmail,
        'enabledNFAOPT': value.enabledNFAOPT,
        'firstName': value.firstName,
        'firstSurname': value.firstSurname,
        'id': value.id,
        'logisticOperationsPermissions': value.logisticOperationsPermissions === undefined ? undefined : Array.from(value.logisticOperationsPermissions as Set<any>),
        'masterdataPermissions': value.masterdataPermissions === undefined ? undefined : Array.from(value.masterdataPermissions as Set<any>),
        'reportsPermissions': value.reportsPermissions === undefined ? undefined : Array.from(value.reportsPermissions as Set<any>),
        'roles': value.roles === undefined ? undefined : Array.from(value.roles as Set<any>),
        'secondSurname': value.secondSurname,
        'tenantId': value.tenantId,
        'trackAndTracePermissions': value.trackAndTracePermissions === undefined ? undefined : Array.from(value.trackAndTracePermissions as Set<any>),
        'username': value.username,
        'validated': value.validated,
    };
}

